export type OrbState = 'idle' | 'listening' | 'thinking' | 'speaking' | 'muted'

export type RowKey = 'car' | 'bat' | 'addr' | 'slot' | 'contact' | 'pay'

export const ROW_DEFS: { key: RowKey; label: string }[] = [
	{ key: 'car', label: 'Autó' },
	{ key: 'bat', label: 'Akkumulátor' },
	{ key: 'addr', label: 'Helyszín' },
	{ key: 'slot', label: 'Időpont' },
	{ key: 'contact', label: 'Kapcsolat' },
	{ key: 'pay', label: 'Fizetés' },
]

export interface ConfirmCard {
	label: string
	value: string
	note?: string
	noteGreen?: boolean
	green?: boolean
	leaving?: boolean
}

export interface Chip {
	id: string
	label: string
	primary?: boolean
}

export interface BatteryOption {
	id: string
	name: string
	short: string
	spec: string
	price: string
	tag?: string
	reason: string
	img: string
	state: 'normal' | 'chosen' | 'dimmed'
}

export interface PriceInfo {
	total: string
	lines: { k: string; v: string }[]
	leaving?: boolean
}

export interface DraftInfo {
	code: string
	phone: string
}

export interface SuccessInfo {
	orderNo: string
	slot: string
}

export interface VoiceState {
	phase: 'entrance' | 'conversation'
	entranceLeaving: boolean
	orb: OrbState
	assistantLine: string
	/** bumped per utterance so the fade-in replays on each new line */
	lineId: number
	userEcho: string
	echoId: number
	/** 'dictate' → status line shows „Mondja el — vagy írja be lent" */
	statusHint: 'none' | 'dictate'
	card: ConfirmCard | null
	options: BatteryOption[] | null
	chips: Chip[]
	price: PriceInfo | null
	draft: DraftInfo | null
	success: SuccessInfo | null
	sum: Partial<Record<RowKey, string>>
	total: string
	expanded: boolean
	holdOn: boolean
	holdLeft: number
	listening: boolean
	done: boolean
	phoneShown: boolean
}

/** Everything the UI can ask of the conversation engine — the scripted demo
    driver and the Realtime bridge both implement this. */
export interface Driver {
	start(withMic: boolean): Promise<void>
	pickChip(chip: Chip): void
	pickOption(opt: BatteryOption): void
	submitText(text: string): void
	toggleMic(): void
	editRow(key: RowKey, label: string): void
	/** First mid-flow „Hívás" tap — driver decides the draft-code card. */
	callTapped(): void
	dispose(): void
}
